import { render } from "./TypesShowView.vue?vue&type=template&id=be689eb0"
import script from "./TypesShowView.vue?vue&type=script&lang=js"
export * from "./TypesShowView.vue?vue&type=script&lang=js"

import "./TypesShowView.vue?vue&type=style&index=0&id=be689eb0&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__